// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"b5f779f4","693":"0e6ed2ac","766":"fc5bd5df","774":"ca1972d8","899":"0717f386","921":"ba617046","931":"946f4ec9"}[chunkId] + ".chunk.js";
};